export const ORDER_INDICATORS_NAMES = {
  CUSTOM_STORE_ORDER: 'Custom store order',
  INVENTORY_ORDER: 'Inventory order',
  BOX_ORDER: 'Box order',
  BUNDLE_ORDER: 'On demand box',
  BLANK_SAMPLE_ORDER: 'Blank sample',
  PRINTED_SAMPLE_ORDER: 'Printed sample',
  RUSHED_PRODUCTION_ORDER: 'Rushed production',
  RUSHED_DELIVERY_ORDER: 'Rushed delivery',
  PENDING_APPROVAL: 'Pending approval',
  DUMMY_ORDER: 'Dummy order',
  TO_INVENTORY_AND_KEEP: 'Hold in stock',
  TO_INVENTORY_AND_DISTRIBUTE: 'Distribute right away',
  FIRST_INVENTORY_ORDER: 'FIO',
  GIVEAWAY_NOTECARD: 'Giveaway notecard',
  INTERNATIONAL_ORDER: 'International order',
  EXPIRABLE_PRODUCTS: 'Expiring products',
  REPLACEMENT_ORDER: 'Replacement order',
  SPLIT_SHIPPED: 'Split shipped',
  IS_SILENT: 'Silent order',
  CBS_ORDER: 'CBS order',
  FORBIDDEN_TO_SHIP_INTERNATIONALLY: 'Restricted item'
};